import { useParams } from "react-router-dom";
import i18n from "@/i18n";
import { AuditCard } from "@/features/Audit/AuditCard";
import { EditCardWrapper } from "@/features/Edit/EditCardWrapper";
import { k1ManagementCompaniesEditForm } from "./edit_form";

const client = "k1";
const table_name = "k1_management_companies";

export default function K1ManagementCompaniesEdit() {
  const { id } = useParams<{ id: string }>();
  const numericId = Number(id);
  const isValidId = id != null && Number.isInteger(numericId) && numericId > 0;

  if (!isValidId) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 min-h-full">
      <div className="flex flex-col gap-10 p-10">
        <EditCardWrapper
          client={client}
          id={numericId}
          headerText={i18n.t(`${table_name}.title`, {
            ns: "tables",
            defaultValue: "Management Company",
          })}
          {...k1ManagementCompaniesEditForm}
        />
        <AuditCard id={numericId} client={client} audit_table_name={table_name} />
      </div>
    </div>
  );
}
